export const projectDetails = [
  {
    title: "NASA API Key",
    duration: "2019 - 1 month",
    thumbnail: "https://kobalt-pics.s3.amazonaws.com/developer/Screen+Recording+2020-12-30+at+10.58.03+PM.gif",
    description: ["The purpose of this project is to showcase NASA's Picture of the Day. Therefore, I have prioritized the image set to the background by making the calendar and accompanying description almost completely see-through. You can read the text by moving the mouse over the text.", "NASA has provided software engineers various Application Programming Interfaces (APIs) to practice with. In order to gain access to these APIs, we must request a unique API key. With this key, we make a request to the API and in the response, we receive an object that has the image, title, description, credit, etc. Through some basic JavaScript and CSS, I have taken the image that comes in the response and set it to the background. This specific API has images stored for every day of the year going all the way back to July 16th, 1995."],
    demo: "https://nasa-apikey.netlify.app/",
    code: "https://github.com/WEB27-practice/NASA-API-Photos",
    roles: ["Coder", "Designer"]
  },
  {
    title: "Computer Science - Conway's Game of Life",
    duration: "2020 - 1 week",
    thumbnail: "https://kobalt-pics.s3.amazonaws.com/developer/seans-game-of-life.gif",
    description: ["Sean's Game of Life is an implementation of John Horton Conway&#39;s Game of Life written in React. This version of Conway's Game of Life takes advantage of hooks to handle state for the app. In the project, I apply Immer's built-in default function, 'produce', to manage double-buffering when the grid switches from one generation to another. Additionally, each generation is saved in a cache so that a player can easily view previous boards after the animation has started and been paused."],
    demo: "https://seans-game-of-life.netlify.app/",
    code: "https://github.com/seanaleid/cs-build-week-1",
    roles: ["Coder", "Designer"]
  },
  {
      title: "Replate",
      duration: "2019 - 1 week",
      thumbnail: "https://kobalt-pics.s3.amazonaws.com/developer/Replate.gif",
      description: ["Replate was a Build Week project while I was a Team Lead at Lambda. Build Week brings together a cross functional team of students to build a project. To successfully complete the week long challenge, Replate required a frontend, backend, and marketing site. My role as project manager was to identify the tasks and help the full stack developers complete them within the deadline."
      ],
      demo: "https://replate-seven.now.sh/",
      code: "https://github.com/Replate1",
      roles: ["Project Manager"]
    }
];

// {
//   title: "",
//   duration: "",
//   thumbnail: "",
//   description: [],
//   demo: "",
//   code: "",
//   roles: []
// }